<template>
  <div class="" style="position:fixed">
      <b-container fluid style="padding-top: 100px; ">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">

                <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>
                  <b-breadcrumb-item href="#home">
                    <router-link to="/AS_AllDocuments">
                      নথি
                    </router-link>
                  </b-breadcrumb-item>
                 <b-breadcrumb-item href="#" active>শক্তি সঞ্চয়ৰ বাবে পৰামৰ্শ</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>

        <b-row>
          <b-col cols="12" style="height:75vh; overflow-y:scroll;width:99vw">
          <div class="cntnt">
            <b-row>
              <b-col cols="12">
                  <h1 class="heading">শক্তি সঞ্চয়ৰ বাবে পৰামৰ্শ</h1>
              </b-col>
           </b-row>

           <p class="content">
            <strong>Air Conditioner</strong>
 										 <ul class="a">
 										 <li>Set temperature controls for cooling to 24°C or higher. Lower settings require more cooling energy and may be &apos;fighting&apos; the heat.</li>
 										 <li>Where the design permits, ensure heating and cooling are not on at the same time in the same part of the building.</li>
 										 <li>As much as possible keep the doors of the air conditioning room closed.</li>
 										 <li>A dirty filter in an air conditioner consumes more energy. Clean the filter at least once in a month.</li>
 										 </ul><br />
            <strong>Lighting</strong>
 										 <ul class="a">
 										 <li>Ensure that someone is responsible for switching off lights in each room or area when not in use.</li>
 										 <li>Install lighting controls or time switches to reduce the hours of use of artificial lighting.</li>
 										 <li>Avoid excessive lighting levels and hours of use in corridors. Where fluorescent lighting is used, it may be possible to reduce the number of tubes in use.</li>
 										 <li>Make the best use of daylight by keeping windows and roof lights clean and by using working areas near windows where possible. Encourage staff to turn off lights when daylight is good enough to work by.</li>
 										 <li>Check whether you have the most energy efficient lights in your fittings.</li>
 										 <li>Clean your tube light and bulbs regularly.</li>
                   </ul><br />
           <strong>Refrigerators</strong>
 										 <ul class="a">
 										 <li>Avoid storing hot/warm food in refrigerator.</li>
 										 <li>Allow adequate air circulation inside the refrigerator.</li>
 										 <li>Allow space for continuous airflow around refrigerator.</li>
 										 <li>Keep the refrigerator away from all source of heat.</li>
 										 <li>Make sure the refrigerator rubber seals are clean and tight.</li>
 										 <li>Defrost freezer compartment regurarly for a manual defrost refrigerator.</li>
 										 </ul><br />
          <strong>Computers</strong>
 										 <ul class="a">
 										 <li>Turn off the office equipment when not in use.</li>
 										 <li>Turn off the monitor when not required. This will save more than 50% of the energy.</li>
 										 <li>Battery charger like those used in laptops uses power whenever plugged in. Pull the plug when not required.</li>
 										 <li>Screen savers save computer screens, not energy. Shutting down the computer when you have finished using them will reduces system wear and saves energy.</li>
 										 </ul><br />
          <strong>Water Heater</strong>
 										 <ul class="a">
 										 <li>To help reduce heat loss, always insulate hot water pipes, especially when they run through unheated areas.</li>
 										 <li>By reducing the temperature setting of water heater from 60 degrees to 50 degrees C, one could save over 18 % of the energy used at the highest setting.</li>
 										 </ul><br />
          <strong>Microwave Ovens and Electric Kettles</strong>
 										 <ul class="a">
 										 <li>Microwaves save energy by reducing cooking time. In fact one can save up to 50 percent on your cooking energy costs by using microwave oven instead of a regular oven, especially for small quantities of food.</li>
 										 <li>Remember, microwaves cook food from the outside edge towards the centre of the dish, so if your cooking more than one item, place larger and thicker items on the outside.</li>
 										 <li>Use an electric kettle to heat water, It&apos;s more energy efficient than using an electric cook top element.</li>
 										 <li>When buying a new electric kettle, choose one that had an automatic shut-off button and a heat-resistant handle.</li>
 										 <li>Regularly clean your electric kettle by combining boiling water and vinegar to remove mineral deposits.</li>
 										 <li>Don&apos;t overfill the kettle for just one drink. Heat only the amount of water you need.</li>
 										 </ul><br />
         <strong>Ventilation</strong>
 										 <ul class="a">
 										 <li>Ensure the main ventilation plant and toilet extractor fans are switched off outside occupancy hours.</li>
 										 <li>Check that windows are not being opened to avoid overheating during winter months - turn down the heating instead.</li>
 										 <li>Ensure kitchen fans are switched off when no cooking is taking place.</li>
 										 </ul><br />
         <strong>Extra Tips</strong>
 										 <ul class="a">
 										 <li>Ensure that all controls are labeled to indicate their function and, if appropriate, their new reduced settings.</li>
 										 <li>Ensure that all insulation is in a state of good repair.</li>
 										 <li>Finally, encourage staff to turn off office equipment when it is not being used.</li>
 										 </ul>
                   </p>
                </div>
          </b-col>
        </b-row>
      </b-container>
      <br><br>
  </div>
</template>



<script>
import Cards from '@/components/DocumentCardComponents.vue'
import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'


export default {
  name: 'Document',
  components: {
    'Cards' : Cards,
      'HeaderFixed' : HeaderFixed,
      'HeaderMobile' : HeaderMobile
  }
}
</script>

<style scoped="true">
li{
  padding:0;
}
ul.a {
  list-style-type: circle;
  padding-left:20px;
}

    body{
      overflow-y:hidden;
    }
.heading {
  border-left: 10px solid #ed7c27;
  border-left-width: 10px;
  border-left-style: solid;
  border-left-color: rgb(237, 124, 39);
  font-size: 25px;
  text-align: left;
  letter-spacing: 1px;
  padding-left: 1rem;
  margin-bottom: 2rem;
  margin-top: 1rem;
  text-transform: capitalize;

}
.content{
    text-align: justify;
line-height: 1.5rem;
font-size:0.9rem;
}
.cntnt{
box-shadow: 0 -2px 15px 0 rgba(0, 0, 0, 0.2), 0 10px 10px 0 rgba(0, 0, 0, 0.19);
padding:10px 30px 10px 30px;


}

table{
  text-align: left !important;
}

.headerF{
  display: block;
}
.headerM{
  display: none;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
  }

</style>
